export default __webpack_public_path__ + "static/grid-mobile-c9b07cafbd760286db9ed269ca0cc269.png";